import { render } from "./PCSalidasProduccion.vue?vue&type=template&id=5b7225ee"
import script from "./PCSalidasProduccion.vue?vue&type=script&lang=js"
export * from "./PCSalidasProduccion.vue?vue&type=script&lang=js"

import "./PCSalidasProduccion.vue?vue&type=style&index=0&id=5b7225ee&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__